import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { H2 } from '@liveauctioneers/hammer-ui-core/text';
import React from 'react';
import styled from 'styled-components';

const SecurityFormHeader = () => (
    <StyledHeaderRow>
        <H2>
            <FormattedMessage id="accountSettings.security.header" />
        </H2>
    </StyledHeaderRow>
);

export default SecurityFormHeader;

const StyledHeaderRow = styled.header`
    display: flex;
    margin-bottom: 16px;
`;
